// Related to the `paginationLimitedTo` settings on the Algolia index
// Should be 1000 by default
export const MAX_ALGOLIA_PAGINATED_RESULTS = 1000

export const MAX_JOB_ADS = 20
